import { getContrastRatio } from '@mui/material/styles';

export const isLightColor = (color) => {
    if (typeof color !== 'string') {
        return false; 
    }

    const contrastRatio = getContrastRatio(color, '#fff');
    return contrastRatio < 3;
};

export const getTextColor = (color) => {
    if (!color || typeof color !== 'string') return '#000';
    try {
        const contrastRatio = getContrastRatio(color, '#fff');
        return (contrastRatio < 2) ? '#000' : '#fff';
    } catch {
        return '#000';
    }
};

export const getCardColor = (lightMode, on = true) => {
    if (lightMode) {
        return on ?  `#ffffff` : `grey.200`;
    } else {
        return on ? `#69686b` : `#3c3e40`;
    }
}

export const isValidHexCode = (color) => {
    const hexRegex = /^#([A-Fa-f0-9]{3}){1,2}$/;
    return hexRegex.test(color);
}

export const hexToRgba = (hex, alpha) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};